import { apiSlice } from '../../../api/common/apiSlice';
import { ApiTagType } from '../../../constants/apiTagType';
import {
  AlpacaFee,
  AlpacaFeeMonthlyReportRow,
  AlpacaFeeShare,
  FetchUserDividendsRequest,
  PaginatedDividends,
  UpdateAlpacaFeeRequest,
} from '../../../types/alpacaFee';

const ALPACA_FEES_URL = '/admin/alpaca-fees';
const ALPACA_DIVIDENDS_URL = '/admin/alpaca-dividends';

export const alpacaFeeApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    fetchAlpacaFees: builder.query<AlpacaFee[], void>({
      query: () => ({ url: ALPACA_FEES_URL, method: 'GET' }),
      providesTags: (res) => [
        ...(res || []).map(({ id }) => ({ type: ApiTagType.AlpacaFee as const, id })),
        { type: ApiTagType.AlpacaFee, id: 'LIST' },
      ],
    }),
    updateAlpacaFee: builder.mutation<AlpacaFee, UpdateAlpacaFeeRequest>({
      query: ({ id, ...data }) => ({ url: `${ALPACA_FEES_URL}/${id}`, method: 'PATCH', body: data }),
      invalidatesTags: (res, error, req) => [{ type: ApiTagType.AlpacaFee, id: req.id }],
    }),
    fetchAlpacaFeeMonthlyReport: builder.query<AlpacaFeeMonthlyReportRow[], string>({
      query: (month) => ({ url: `${ALPACA_FEES_URL}/monthly-report`, method: 'GET', params: { month } }),
      providesTags: (res, error, month) => [{ type: ApiTagType.AlpacaFeeReport, id: month }],
    }),
    fetchAlpacaRequestFees: builder.query<AlpacaFeeShare[], string>({
      query: (madkholOrderId) => ({
        url: `${ALPACA_FEES_URL}/request/${encodeURIComponent(madkholOrderId)}`,
        method: 'GET',
      }),
      providesTags: (res, error, madkholOrderId) => [{ type: ApiTagType.AlpacaFeeShare, id: madkholOrderId }],
    }),
    fetchUserDividends: builder.query<PaginatedDividends, FetchUserDividendsRequest>({
      query: ({ userId, limit, offset }) => ({
        url: `${ALPACA_DIVIDENDS_URL}/user/${userId}`,
        method: 'GET',
        params: { limit, offset },
      }),
      providesTags: (res, error, req) => [{ type: ApiTagType.UserDividend, id: req.userId }],
    }),
  }),
});

export const {
  useFetchAlpacaFeesQuery,
  useUpdateAlpacaFeeMutation,
  useFetchAlpacaFeeMonthlyReportQuery,
  useFetchAlpacaRequestFeesQuery,
  useFetchUserDividendsQuery,
} = alpacaFeeApiSlice;
